import React from 'react';

interface GridProps {
  children?: React.ReactNode;
  spacing?: number;
  dotSize?: number;
  color?: string;
  opacity?: number;
  animated?: boolean;
}

const Grid: React.FC<GridProps> = ({ 
  children, 
  spacing = 20,
  dotSize = 1,
  color = "#000000",
  opacity = 0.1,
  animated = true
}) => {
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            radial-gradient(circle at ${dotSize}px ${dotSize}px, ${color} ${dotSize}px, transparent 0)
          `,
          backgroundSize: `${spacing}px ${spacing}px`,
          opacity: opacity,
          pointerEvents: 'none',
          zIndex: 0,
          animation: animated ? 'gridDotPulse 3s ease-in-out infinite' : 'none'
        }}
      />
      <style>
        {`
          @keyframes gridDotPulse {
            0% {
              opacity: ${opacity};
              transform: scale(1);
            }
            50% {
              opacity: ${opacity * 0.5};
              transform: scale(1.05);
            }
            100% {
              opacity: ${opacity};
              transform: scale(1);
            }
          }
        `}
      </style>
      <div style={{ position: 'relative', zIndex: 1 }}>
        {children}
      </div>
    </div>
  );
};

export default Grid;